import React, { useRef, useState } from "react"
import { Heading } from "frontend/components/text"
import { Button } from "frontend/components/interaction"

import t from "frontend/utils/translations"
import styles from "./UploadAgain.module.css"
import CloudUpload from "./CloudUpload"
import LocalUpload from "./LocalUpload"

const UploadAgain = ({ onFileSelection }) => {
  const dropzoneRef = useRef(null)
  const [error, setError] = useState("")

  const handleClick = () => {
    setError("")
    dropzoneRef.current.click()
  }

  return (
    <div className={styles.container}>
      {error && (
        <div className={styles.error}>
          <p>Try Again</p>
          <Heading size={3}>{error}</Heading>
        </div>
      )}
      <div className={styles.local}>
        <p className={styles.cta}>{t("upload.upload_again.prompt")}</p>
        <Button className={styles.button} onClick={handleClick} label={t("upload.upload_again.button")} />
      </div>
      <hr className={styles.hr} />
      <CloudUpload onFileSelection={onFileSelection} setError={setError} />
      <LocalUpload inputRef={dropzoneRef} onFileSelection={onFileSelection} setError={setError} />
    </div>
  )
}

export default UploadAgain
